<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image poc-splash" v-if="!isMobile()">
                                        <img alt="Solar support PoC" src="./assets/solar-system.svg">
                                    </figure>
                                    <figure class="image poc-splash mobile-screen" v-else>
                                        <img alt="Solar support PoC" src="./assets/solar-system.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('poc:poc.subtitle') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('poc:poc.subtitle_description') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Platorm section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('poc:poc.platform_title_up')">
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-500" v-if="!isMobile()">
                            <img alt="Iran coverage" src="./assets/iran-network.svg">
                        </figure>
                        <figure class="image img-500 mobile-screen" v-else>
                            <img alt="Iran coverage" src="./assets/iran-network.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc:poc.platform_description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <router-link :to="'poc-network-description'" class="uptin-text-center uptin-text-center text-yellow" active-class="is-active is-active--advertiser">
                            {{ $t('poc:poc.platform_more') }}
                            <i v-bind:class = "isPersian(currentLocale)?'fas fa-angle-left':'fas fa-angle-right'" style="color: #ffbb00;"></i>
                        </router-link>
                    </div>
                </div>

            </div>
        </section>

        <!-- Economic section -->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('poc:poc.effordable-title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-300" v-if="!isMobile()">
                            <img alt="Pay as you go payment" src="./assets/cost-section.svg">
                        </figure>
                        <figure class="image img-300 mobile-screen" v-else>
                            <img alt="Pay as you go payment" src="./assets/cost-section.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center">
                            {{ $t('poc:poc.effordable-description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-2x uptin-text-center">
                        <router-link :to="'poc-vs-radio'" class="uptin-text-center uptin-text-center text-dark" active-class="is-active is-active--advertiser">
                            {{ $t('poc:poc.poc_vs_radio') }}
                            <i v-bind:class = "isPersian(currentLocale)?'fas fa-angle-left text-dark':'fas fa-angle-right text-dark'"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>

        <!-- Limitless section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('poc:poc.feedback_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-300" v-if="!isMobile()">
                            <img alt="Unlimited user and group" src="./assets/unlimited-section.svg">
                        </figure>
                        <figure class="image img-300 mobile-screen" v-else>
                            <img alt="Unlimited user and group" src="./assets/unlimited-section.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center text-white">
                            {{ $t('poc:poc.feedback_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Secure section-->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('poc:poc.secure_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-300" v-if="!isMobile()">
                            <img alt="Security aspects" src="./assets/security-section.svg">
                        </figure>
                        <figure class="image img-300 mobile-screen" v-else>
                            <img alt="Security aspects" src="./assets/security-section.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column intro-text content small-container">
                        <p class="small-container uptin-text-center uptin-text-center">
                            {{ $t('poc:poc.secure_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">
    .poc-splash {
        max-width: 450px;
        min-width: 450px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"

    export default {
        components: {
            PayAsYouGo
        },
        name: 'uptin-poc',
        data() {
            return {
                currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
            };
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            isPersian(locale) {
                return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
            }
        }
    }
</script>
